// src/pages/expense/cafe/ExpenseCafeGreenDraftNew.jsx
// ✅ 전 사업 확산 [5] — 카페인 그린점 "지출데이터+기안 작성" 페이지. 실제 로직은
// pages/expense/_shared/ExpenseDraftNew.jsx(공통 컴포넌트)에 있고, 이 파일은
// 그린점 전용 config(greenDraftConfig.js)를 넘기는 얇은 래퍼일 뿐이다.
import React from "react";
import ExpenseDraftNew from "../_shared/ExpenseDraftNew";
import greenDraftConfig from "./greenDraftConfig";

export default function ExpenseCafeGreenDraftNew() {
  return <ExpenseDraftNew config={greenDraftConfig} />;
}
